import { render, staticRenderFns } from "./SButton.vue?vue&type=template&id=35207fbd&scoped=true&"
import script from "./SButton.vue?vue&type=script&lang=js&"
export * from "./SButton.vue?vue&type=script&lang=js&"
import style0 from "./SButton.vue?vue&type=style&index=0&id=35207fbd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35207fbd",
  null
  
)

export default component.exports